import { ComposeWizard } from '../components/ComposeWizard';

export function AddVoiceCampaignPage() {
  return (
    <ComposeWizard
      mode="create"
      pageTitle="Compose Campaign"
      pageDescription="Build a new outbound voice campaign in six steps."
    />
  );
}
